import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=fb6a3aee&scoped=true&"
import script from "./DialogMessage.vue?vue&type=script&lang=ts&"
export * from "./DialogMessage.vue?vue&type=script&lang=ts&"
import style0 from "./DialogMessage.vue?vue&type=style&index=0&id=fb6a3aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6a3aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VDialog})
